import { orderItemKey } from '../../utils/orderItemKeys';
import React, { useState } from 'react';
import { BASE_URL } from '../../shared/constants';
import {
  getClassNameForProductOrderType,
  getClassNameForProductStatus,
  renderPrice,
} from '../../utils/adminOrderService';
import { formatExpectedArrivalDate } from '../../utils/utils';
import { Link } from 'react-router-dom';
import { isOrderItemInStock } from '../../utils/stockQuantities';
import ProductDiscountImage from '../ProductDiscountImage';
import { productImagePaths } from '../../utils/productImages';
import '../../styles/common.css';

const OrderItemDesktop = ({
  item,
  setModalImage,
  handleEditClick,
  selected = false,
  onToggleSelect,
}) => {
  const imagePath = productImagePaths(item)[0];
  const handleImageClick = (imagePath) => {
    setModalImage(imagePath);
  };
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className={`d-flex align-items-center${isOrderItemInStock(item) ? '' : ' order-item-status-warning'}`}>
      {onToggleSelect && (
        <label
          className='d-inline-flex align-items-center justify-content-center flex-shrink-0 mb-0 mr-2'
          style={{ width: '28px', minWidth: '28px', height: '28px', cursor: 'pointer' }}
          title={`Обрати ${item.name}`}
        >
          <input
            type='checkbox'
            className='m-0'
            checked={selected}
            onChange={() => onToggleSelect(orderItemKey(item))}
            aria-label={`Обрати ${item.name}`}
            style={{ width: '1rem', height: '1rem', margin: 0, cursor: 'pointer', position: 'static' }}
          />
        </label>
      )}
      <div className='flex-grow-1 min-width-0'>
        <div className='row align-items-center'>
          <div className='col-1 d-flex align-items-center'>
            {imagePath && (
              <ProductDiscountImage price={item.price} discountedPrice={item.discountedPrice}
                personalDiscount={item.personalDiscount} productDiscount={item.productDiscount}>
                <img
                  src={BASE_URL + '/api/v1/product/image/' + imagePath}
                  alt={item.name}
                  className='img-fluid'
                  onClick={() => handleImageClick(imagePath)}
                  style={{ cursor: 'pointer' }}
                  data-toggle='modal'
                  data-target='#imageModal'
                />
              </ProductDiscountImage>
            )}
          </div>

          <div className='col-5'
               onMouseEnter={() => setIsHovered(true)}
               onMouseLeave={() => setIsHovered(false)}>
            <div className='font-weight-bold mb-2'>
              {item.name}
              {item.state && item.state.databaseValue && item.state.databaseValue === 'PREORDER' && (
                <span className="font-weight-bold">
                  {' '}[В передзамовленні{item.expectedArrivalDate && formatExpectedArrivalDate(item.expectedArrivalDate) ? `, очікується ${formatExpectedArrivalDate(item.expectedArrivalDate)}` : ''}]
                </span>
              )}
              {item.state && item.state.databaseValue && item.state.databaseValue !== 'PREORDER' && item.parentProductName && (
                (<span className="font-weight-bold"> [{item.parentProductName}]</span>)
              )}
              {isHovered && (
                <Link to={'/product/' + item.productId} style={{ color: 'black', marginLeft: '2px' }}>
                  <i className='bi bi-forward-fill'></i>
                </Link>
              )}
            </div>
            <div className='admin-order-item-desktop-details'>
              {(item.productCode || item.barcode) && <div className='admin-order-item-desktop-identifiers'>
                {item.productCode && <div><span>Артикул:</span><b>{item.productCode}</b></div>}
                {item.barcode && <div><span>Штрихкод:</span><b>{item.barcode}</b></div>}
              </div>}
              {item.unsentQuantity !== undefined && item.unsentQuantity !== null && (
                <div><span>На складі:</span><b>{item.unsentQuantity} шт</b></div>
              )}
              {item.promCommission != null && item.promCommission > 0 && (
                <div><span>Комісія Прому:</span><b>{item.promCommission} грн</b></div>
              )}
            </div>
          </div>

          <div className='col-1 d-flex'>
            <span className={`mx-2 ${item.quantity > 1 ? 'text-danger font-weight-bold' : ''}`}>{item.quantity} шт</span>
            <a
              className='cursor-pointer text-dark'
              onClick={() => handleEditClick(item)}
              data-toggle='modal'
              data-target='#editQuantityModal'>
              <i className='bi bi-pencil-fill text-dark'></i>
            </a>
          </div>

          <div className='cursor-pointer col-2 d-flex'
               onClick={() => handleEditClick(item)}
               data-toggle='modal'
               data-target='#changeDiscountModal'>
            {renderPrice(item)}
            <a
              className='cursor-pointer pl-1 font-weight-bold text-dark'
              onClick={() => handleEditClick(item)}
              data-toggle='modal'
              data-target='#changeDiscountModal'>
              <i className='bi bi-percent'></i>
            </a>
          </div>

          <div className='col-2 d-flex flex-column align-items-center text-center'>
            <span className={item.productOrderType ? getClassNameForProductOrderType(item.productOrderType.databaseValue) : ''}>
              {item.productOrderType ? item.productOrderType.clientValue : 'Не визначено'}
            </span>
            <span className={`text-truncate ${item.productStatus ? getClassNameForProductStatus(item.productStatus.databaseValue) : ''}`}>
              {item.productStatus ? item.productStatus.shortValue : 'Не визначено'}
            </span>
          </div>

          <div className='col-1 d-flex justify-content-center'>
            <a
              className='cursor-pointer text-dark pr-2'
              onClick={() => handleEditClick(item)}
              data-toggle='modal'
              data-target='#editProductOrderModal'>
              <i className='bi bi-pencil-fill text-dark'></i>
            </a>
            <a
              className='cursor-pointer text-danger'
              onClick={() => handleEditClick(item)}
              data-toggle='modal'
              data-target='#confirmDeleteModal'>
              <i className='bi bi-trash-fill'></i>
            </a>
          </div>
          <div className="w-100 border-bottom mt-2"></div>
        </div>
      </div>
    </div>
  );
};

export default OrderItemDesktop;
